import { render, staticRenderFns } from "./DeviceAdminCom.vue?vue&type=template&id=95426184&"
import script from "./DeviceAdminCom.vue?vue&type=script&lang=ts&"
export * from "./DeviceAdminCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports